import { Controller } from '@hotwired/stimulus'
import { useEventListener } from '~/controllers/concerns/use_event_listener'

export default class extends Controller {
  static targets = ['iframe', 'select']
  static values = {
    selectableItemIds: Array,
    selectedItemIds: Array
  }

  connect() {
    useEventListener(this, {
      element: this.iframeTarget.contentWindow,
      event: 'selection:change',
      listener: 'onSelectionChange'
    })

    useEventListener(this, {
      element: this.iframeTarget.contentWindow,
      event: 'load',
      listener: 'prepareSelection',
      listenerOptions: { once: true }
    })
  }

  prepareSelection() {
    const document = this.iframeTarget.contentDocument
    const form = document.querySelector('[data-selection-form]')
    const frame = document.querySelector('[data-selection-frame]')

    form.querySelector('input[name$="[selectable_items_ids]"]').value = this.selectableItemIdsValue.join(',')
    form.querySelector('input[name$="[selected_items_ids]"]').value = this.selectedItemIdsValue.join(',')

    if (frame.getAttribute('complete') !== null) {
      return form.requestSubmit()
    }

    frame.addEventListener('turbo:frame-load', () => form.requestSubmit(), { once: true })
  }

  onSelectionChange(e) {
    const { selectedItemsIds } = e.detail

    for (const option of this.selectTarget.options) {
      option.selected = selectedItemsIds.includes(option.value)
    }
  }
}
